import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../../../../core/auth';
import { QualityTypeService } from '../../../../../core/plant-configuration/_services/quality-type.service';

@Component({
  selector: 'kt-quality-type-edit',
  templateUrl: './quality-type-edit.component.html',
  styleUrls: []
})
export class QualityTypeEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required],
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon2-user-outline-symbol", title: "Defina el tipo de calidad", subTitle: "Ingrese el nombre", form: [
        [
          { name: "name", label: "Nombre", type: "text" },          
        ],
      ]
    },
  ];

  private subscriptions: Subscription[] = [];
  data: any = {};
  partnerList: any[];
  userList: any[];
  uid: number = -1;

  constructor(
    private qualityTypeService: QualityTypeService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();
    console.log("uid: "+this.uid);
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {

    console.log("on item load:");
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.qualityTypeService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        this.itemObs.next(item);
      })
    )
  }

  addItem(item: any) {
    item.create_uid = this.uid>0?this.uid:'null';
    // item.create_date = 0;
    item.write_uid = this.uid>0?this.uid:'null';
    // item.write_date = 0;
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.qualityTypeService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item: any) {
    item.write_uid = this.uid>0?this.uid:'null';
    // item.write_date = 0;
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.qualityTypeService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item.id);
        else this.editObs.next(-1);
      })
    )
  }
}